import { Type } from "@scalar/typebox";
const XScalarIgnoreSchema = Type.Object({
  "x-scalar-ignore": Type.Optional(Type.Boolean())
});
export {
  XScalarIgnoreSchema
};
//# sourceMappingURL=x-scalar-ignore.js.map
